module.exports = __webpack_public_path__ + "static/img/per13.3ae36af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/per13.jpg
// module id = xWIV
// module chunks = 41